import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
    TemplateRef,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { NewsFeedModel } from '../news-feed.model';
import { NewsFeedItemContentPostComponent } from './news-feed-item-content-post/news-feed-item-content-post.component';
import { NewsFeedItemContentDocumentComponent } from './news-feed-item-content-document/news-feed-item-content-document.component';
import { NewsFeedItemContentChecklistComponent } from './news-feed-item-content-checklist/news-feed-item-content-checklist.component';
import { NewsFeedItemContentMediaBankComponent } from './news-feed-item-content-media-bank/news-feed-item-content-media-bank.component';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { NewsFeedItemContentFormComponent } from '@fi-app/news-feed/news-feed-item-content/news-feed-item-content-form/news-feed-item-content-form.component';
import { Subject } from 'rxjs';
import { NewsFeedItemContentFormReminderComponent } from '@fi-app/news-feed/news-feed-item-content/news-feed-item-content-form-reminder/news-feed-item-content-form-reminder.component';
import { NewsFeedItemContentTaskReminderComponent } from '@fi-app/news-feed/news-feed-item-content/news-feed-item-content-task-reminder/news-feed-item-content-task-reminder.component';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { NewsFeedItemContentPkComponent } from '@fi-app/news-feed/news-feed-item-content/news-feed-item-content-pk/news-feed-item-content-pk.component';
import { NewsFeedItemContentBalooComponent } from '@fi-app/news-feed/news-feed-item-content/news-feed-item-content-baloo/news-feed-item-content-baloo.component';
import { INewsFeedVisibleArgs } from '@fi-shared/fi-news-feed-shared/fi-news-feed-visibility-helper/fi-news-feed-visibility-helper.component';

@Component({
    selector: 'fi-news-feed-item-content',
    templateUrl: './news-feed-item-content.component.html',
    styleUrls: ['./news-feed-item-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-news-feed-item-content' },
    standalone: false,
})
export class NewsFeedItemContentComponent {
    @Input() newsItem: NewsFeedModel;
    @Input() newsItemMediaBankReferences: IMediaBankFileReference[] = [];

    @Input() highlightText: string;
    @Input() showWithContentOpened: boolean;

    @ViewChild('post', { static: true }) templateRefPost: TemplateRef<NewsFeedItemContentPostComponent>;
    @ViewChild('document', { static: true }) templateRefDocument: TemplateRef<NewsFeedItemContentDocumentComponent>;
    @ViewChild('media', { static: true }) templateRefMedia: TemplateRef<NewsFeedItemContentMediaBankComponent>;
    @ViewChild('checklist', { static: true }) templateRefChecklist: TemplateRef<NewsFeedItemContentChecklistComponent>;
    @ViewChild('form', { static: true }) templateRefForm: TemplateRef<NewsFeedItemContentFormComponent>;
    @ViewChild('formReminder', { static: true })
    templateRefFormReminder: TemplateRef<NewsFeedItemContentFormReminderComponent>;
    @ViewChild('taskReminder', { static: true })
    templateRefTaskReminder: TemplateRef<NewsFeedItemContentTaskReminderComponent>;
    @ViewChild('pk', { static: true }) templateRefPK: TemplateRef<NewsFeedItemContentPkComponent>;
    @ViewChild('baloo', { static: true }) templateRefBaloo: TemplateRef<NewsFeedItemContentBalooComponent>;

    @Output() becomeVisible = new EventEmitter<INewsFeedVisibleArgs>();
    @Output() becomeInvisible = new EventEmitter();

    afterSavePost$ = new Subject<void>();

    getComponentTemplate() {
        if (this.newsItem.ObjectType === ObjectTypes.Post || this.newsItem.ObjectType === ObjectTypes.ForumPost)
            return this.templateRefPost;

        if (this.newsItem.ObjectType === ObjectTypes.Document) return this.templateRefDocument;

        if (this.newsItem.ObjectType === ObjectTypes.MediaBank) return this.templateRefMedia;

        if (this.newsItem.ObjectType === ObjectTypes.CheckList) return this.templateRefChecklist;

        if (this.newsItem.ObjectType === ObjectTypes.MediaBankGrouped) return this.templateRefMedia;

        if (this.newsItem.ObjectType === ObjectTypes.Form) return this.templateRefForm;

        if (this.newsItem.ObjectType === ObjectTypes.FormReminder) return this.templateRefFormReminder;

        if (this.newsItem.ObjectType === ObjectTypes.TaskReminder) return this.templateRefTaskReminder;

        if (this.newsItem.ObjectType === ObjectTypes.PKImportLog) return this.templateRefPK;

        if (this.newsItem.ObjectType === ObjectTypes.BalooSyncLog) return this.templateRefBaloo;

        throw new Error('Wrong item object type ' + this.newsItem.ObjectType);
    }

    onContentBecomeVisible($event: INewsFeedVisibleArgs) {
        this.becomeVisible.emit($event);
    }

    onContentBecomeInvisible() {
        this.becomeInvisible.emit();
    }

    onAfterSavePost() {
        this.afterSavePost$.next();
    }
}
